import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import * as React from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { FeatureEnum } from '../../services/data/impl/cube/cubeSlice';
import { useTranslation } from '../../services/translation/hooks/useTranslation';
import {
  selectImageMaskVisibility,
  setImageMaskLayerVisibility,
} from './imageSlice';
interface Props {
  layer: FeatureEnum;
  disabled?: boolean;
}

const ImageLayerCheckboxWithLabel: React.FC<Props> = ({
  layer,
  disabled = false,
}) => {
  const dispatch = useAppDispatch();
  const isVisible = useAppSelector(selectImageMaskVisibility)[layer];
  const { t } = useTranslation();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setImageMaskLayerVisibility({ layer, newValue: event.target.checked })
    );
  };

  return (
    <FormGroup sx={{ ml: '1rem' }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={isVisible}
            onChange={handleChange}
            disabled={disabled}
            color='primary'
          />
        }
        label={t(layer)}
        sx={{
          whiteSpace: 'nowrap',
          mr: '0.2rem',
          '& .MuiTypography-root': {
            mb: '-2px',
          },
        }}
      />
    </FormGroup>
  );
};

export default ImageLayerCheckboxWithLabel;
